<template>
  <mailing
    :entry="mailing"
  />
</template>

<script>
import { mapActions } from 'vuex'
import Mailing from '@/components/mailings/Mailing'

export default {
  name: 'Newsletter',
  components: {
    Mailing
  },
  data () {
    return {
      mailing: null
    }
  },
  methods: {
    ...mapActions ({
      fetchMailing: 'mailing/entry/fetchMailing'
    })
  },
  created () {
    const mailingId = this.$route.params.id
    this.fetchMailing(mailingId)
      .then(({data}) => {
        this.mailing = data['GetMailing']
        this.$emit('loadingDone')
      })
  }
}
</script>

<style lang="sass">
.section
  &__headline
    color: red
    font-size: 20px
    margin-top: 50px

.content
  &__title
    font-size: 24px
    line-height: 28px
    margin: 50px 0 25px 0

  &__link
    color: #000

  &__teaser-text
    font-size: 16px
    line-height: 22px
    padding: 25px 0

  &__image
    height: 195px
    overflow: hidden
    position: relative

    img
      display: inline-block
      width: 100%
      position: absolute
      top : 50%
      left: 50%
      transform: translate(-50%, -50%)

  &__footer
    font-size: 14px
    font-weight: 900
    color: #888B95
    padding: 25px 0 45px 0
    border-top: 1px dashed #E2E5EA
    border-bottom: 1px solid #E2E5EA
</style>




// WEBPACK FOOTER //
// src/pages/newsletter/NewsletterPage.vue